import accountingCareers from "./accounting";
import capitalMarketsCareers from "./capitalMarkets";
import marketResearchCareers from "./marketResearch";
import transactionAdvisoryCareers from "./transactionAdvisory";
import dataAnalyticsCareers from "./dataAnalytics";

const careerJobs = [
...accountingCareers,
...capitalMarketsCareers,
...marketResearchCareers,
...transactionAdvisoryCareers,
...dataAnalyticsCareers
];

export default careerJobs;